(() => {
if (customElements.get("swiper-slideshow")) return;
class SwiperSlideshow extends HTMLElement {
	connectedCallback() {
		if (this.swiper) return;
		this.initSwiper();
		if (!this.swiper && !this.childrenObserver) {
			this.childrenObserver = new MutationObserver(() => this.initSwiper());
			this.childrenObserver.observe(this, { childList: true, subtree: true });
		}
	}

	disconnectedCallback() {
		this.childrenObserver?.disconnect();
		this.childrenObserver = null;
		this.swiper?.destroy(true, true);
		this.swiper = null;
	}

	initSwiper() {
		if (this.swiper || !this.isConnected) return;
		this.container = this.querySelector(".c-swiper-slideshow__container");
		if (!this.container) return;
		// Wait for the complete section when children are parsed or inserted later.
		if (!this.container.querySelector(".swiper-slide") || !this.querySelector(".swiper-pagination") || !this.querySelector(".swiper-button-next") || !this.querySelector(".swiper-button-prev")) return;
		this.autoplayValue = this.dataset.autoplay || "false";
		this.effect = this.dataset.effect || "slide";

		// 自動再生の設定
		const autoplayConfig =
			this.autoplayValue !== "false"
				? {
						delay: parseInt(this.autoplayValue),
						disableOnInteraction: false,
				  }
				: false;

		// 基本設定
		const config = {
			autoHeight: this.dataset.autoHeight === "true",
			loop: true,
			autoplay: autoplayConfig,
			slidesPerView: 1,
			spaceBetween: 0,
			speed: 1000,
			pagination: {
				el: this.querySelector(".swiper-pagination"),
				clickable: true,
				type: "bullets",
				renderBullet: function (index, className) {
					return '<span class="' + className + '"></span>';
				},
			},
			navigation: {
				nextEl: this.querySelector(".swiper-button-next"),
				prevEl: this.querySelector(".swiper-button-prev"),
				hideOnClick: false,
				disabledClass: "swiper-button-disabled",
			},
		};

		// エフェクトの設定
		if (this.effect === "fade") {
			config.effect = "fade";
			config.fadeEffect = {
				crossFade: true,
			};
		} else {
			config.effect = "slide";
		}

		// Swiperの初期化
		this.swiper = new Swiper(this.container, config);
		this.childrenObserver?.disconnect();
		this.childrenObserver = null;
	}
}

customElements.define("swiper-slideshow", SwiperSlideshow);

})();
